import React from 'react';
import { useTranslation } from 'react-i18next';
import { DisplayS, Input, ButtonCur } from './Calculator.styled';
import Icons from 'images/allSvgFinTrack.svg';

export const Display = ({ input, setInput, answer, setOpenCalculator, setAnswer }) => {
  const { t } = useTranslation();
  const onChangeTagInput = e => {
    const re = /^[0-9!%()-+\x2D^glox\xF7\u221A]+$/; 

    if (e.target.value === '' || re.test(e.target.value)) {
      setInput(e.target.value);
      setAnswer(e.target.value);
    }
  };
  const onDisplayClick = () => {
    setOpenCalculator(prevState => !prevState);
  };

  return (
    <>
      <DisplayS>
        <ButtonCur type="button" onClick={onDisplayClick}>
          <svg aria-hidden="true" focusable="false">
            <use href={`${Icons}#icon-calculator`}></use>
          </svg>
        </ButtonCur>
        {answer === '' ? (
          <>
            <Input
              type="text"
              name="input"
              style={{ fontsize: '16px' }}
              value={input}
              placeholder={t('placeholder.amountZero')}
              maxLength={20}
              onChange={onChangeTagInput}
              autoComplete="off"
            />
          </>
        ) : (
          <>
            <Input
              type="text"
              name="value"
              style={{ fontsize: '16px' }}
              value={answer}
              onChange={onChangeTagInput}
            />
          </>
        )}
      </DisplayS>
    </>
  );
};
